/** Rough ETA for the import run (same heuristic as the former run step). */
export const estimateImportDurationMinutes = (itemsCount: number): number => {
  if (itemsCount <= 0) {
    return 0;
  }
  return Math.max(1, Math.ceil(itemsCount / 3));
};
